import { GetterTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";


const keuringPlatformGetters: GetterTree<IPropertyEditState, {}> = <GetterTree<IPropertyEditState, {}>>{
  service: (state: IPropertyEditState) => state.service,

  //Certinergie, L'Esprit
  certinergie: (state: IPropertyEditState) => state.keuringPlatform,
  certinergieAgencyInfos: (state: IPropertyEditState) => state.keuringPlatform.AgencyInfo,
  certinergieOwner: (state: IPropertyEditState) => state.keuringPlatform.OwnerInfo,
  certinergieContactInfo: (state: IPropertyEditState) => state.keuringPlatform.ContactInfo,

  // Certiplus
  certiplus: (state: IPropertyEditState) => state.keuringPlatform,
  certiplusAgencyInfos: (state: IPropertyEditState) => state.keuringPlatform.AgencyInfo,
  certiplusOwner: (state: IPropertyEditState) => state.keuringPlatform.OwnerInfo,
  certiplusContactInfo: (state: IPropertyEditState) => state.keuringPlatform.ContactInfo,
}

export default keuringPlatformGetters;